import React, { useState, useEffect } from 'react'
import './profile.scss'
import { useLocation } from "react-router-dom";
import API_CONSTANTS from './../../api-constants'


const AdminProfile = ({ iframeId, appHeightChanged }) => {
  
    const location = useLocation();
    const logins = location?.state?.login_info
    const key = sessionStorage.getItem('key')
   
    let current_pw = sessionStorage.getItem('login_pw')
  
    const [profileChanged, setProfileChanged] = useState(false)
    const [tlfNumber, setTlfNumber] = useState(logins?.Phone);
    const [name, setName] = useState(logins?.Name);
    const [email, setEmail] = useState(logins?.EMail)
    const [password, setPassword] = useState('');
    const [passwordRepeat, setPasswordRepeat] = useState('');
    const current_password = sessionStorage.getItem('pw')
    const isValidName = /^[a-z ,.'-]+$/i

    const [error, setError] = useState(false)
    const [nameError, setNameError] = useState('')
    const [numberError, setNumberError] = useState('')
    const [passwordError, setPasswordError] = useState("");
    const [passwordRepeatError, setPasswordRepeatError] = useState("");
    const [noPasswordMatch, setNoPasswordMatch] = useState()
    const [networkError, setNewtorkError] = useState('')

    const [passwordValidationCheck, setPasswordValidationCheck] = useState(false)
    const [isNumber, setIsNumber] = useState(false)
    const [isUppercase, setIsUppercase] = useState(false)
    const [specialCharacter, setSpecialCharacter] = useState(false)
    const [minimum, setMinimum] = useState(false)

    useEffect(() => {
        var re = { 'capital': /[A-Z]/ };
        if (re.capital.test(password) === true) {
            setIsUppercase(true)
        }
        else setIsUppercase(false)
    }, [password])

    useEffect(() => {
        var re = { 'digit': /[0-9]/ };
        if (re.digit.test(password) === true) setIsNumber(true)
        else setIsNumber(false)
    }, [password])

    useEffect(() => {
        var re = { 'specialCharacter': /[_!\"#$%&'()*+,\-./:;<=>?@[\\\]^`{|}~]/ };

        if (re.specialCharacter.test(password) === true) setSpecialCharacter(true)
        else setSpecialCharacter(false)

    }, [password])
   
    useEffect(() => {
        if (password.length > 7) setMinimum(true)
        else setMinimum(false)

    }, [password])


    useEffect(() => {
        if (isNumber === true && isUppercase === true && specialCharacter === true && minimum === true) {
            setPasswordValidationCheck(false)
        }
    }, [isNumber, isUppercase, specialCharacter, minimum])
  
    if (window.parent != window) {
        appHeightChanged(iframeId, true)
    }

    const validateName = (e) => {
        if (e.target?.value && e.target.value.match(isValidName)) {
            setName(e.target.value)

        }
    }
    function handleNameChange(e) {
        validateName(e)
        setName(e.target.value)
        setNameError('')
        setError('')

    }

    function handleNumberChange(e) {
        const value = e.target.value.replace(/\D/g, "");
       // console.log(value)
        setTlfNumber(value);
        setNumberError('')
        setError('')
    }

    function handlePasswordChange(e) {
        setPassword(e.target.value)
        setPasswordError('')
        setPasswordRepeatError('')
        setError('')
        setPasswordValidationCheck(true)
    }

    function handleRepeatPasswordChange(e) {
        setPasswordRepeat(e.target.value)
        setPasswordRepeatError('')
        setError('')
    }

    function encodeBase64(str) {
        return window.btoa(new TextEncoder().encode(str).reduce((data, byte) => data + String.fromCharCode(byte), ""));
    }

    function handleSubmit() {
        if (name === '' || tlfNumber === '' || password === '' || passwordRepeat === '') {
            setError(true)
        }
        if (password.length && passwordRepeat.length && password !== passwordRepeat) {
            setError(true)
            setNoPasswordMatch('Adgangskode matcher ikke')
        }
        if (password.length && passwordRepeat.length && password === passwordRepeat) {
            setNoPasswordMatch('')
            setError(false)
        }
        if (name === '') {
            setNameError('Udfyld venligst navn')
        }
        if (tlfNumber === '') {
            setNumberError('Udfyld venligst telefonnummer')
        }
        if (password === '') {
            setPasswordError('Udfyld venligst ny adgangskode')
        }
        if (password.length && passwordRepeat === '') {
            setPasswordRepeatError('Udfyld veligst adgangskode igen')
        }
        if (name.length && !name.match(isValidName)) {
            setNameError('Kun bogstaver i navnet')
        }

        if (tlfNumber !== '' && tlfNumber.length !== 8) {
            setNumberError('Nummeret er forkert')
        }
        else if (isNumber === false || minimum === false || isUppercase === false || specialCharacter === false) {   // check if all 4 password validation is aaplied
            setError(true)
            setPasswordError('Adgangskode matcher ikke krav')
        }
        else if (name.length && name.match(isValidName) && tlfNumber.length === 8 && password.length) { 
            let encoded_password = encodeBase64(password)

            fetch(`${API_CONSTANTS.fetchUrl}/systemnative/customer.asmx/Save?Key=${key}&Email=${email}&Password=${encoded_password}&Name=${name}&Phone=${tlfNumber}`, {
                method: "GET",
                headers: {
                    'ebilletToken': "RGV0IGVyIGVuIGthdCBvZyBpa2tlIGVuIGdyaXM=",
                    'Content-Type': 'application/x-www-form-urlencoded',
                },  
        })
            .then((res) => res.json())
            .then(result => {
            
                if (result.result === 1) {
                    sessionStorage.removeItem('key')
                    setProfileChanged(true)
                    sessionStorage.setItem('login_pw', password)
                    sessionStorage.setItem('newkey', result.key)
                                     
                }
                else {
                    setError(true)
                    setNewtorkError(result.Message)
                }
            })

        }
    }

   

    function deleteProfile() {

    }
  
    return (
        <main>
           
          <p className='profile-title'>Administrer profil</p>
            {profileChanged === true ? <p style={{fontSize:'20px'} }> Din profil oplysninger er nu opdateret!</p> 

            : <div className='loginflow  ' style={{marginTop:'20px'} }>
                <label className='email-label'>Email</label>
                <input className='email-input' value={ email} />
                <label className='email-label'>Navn</label>
                <input className='email-input' type='text' value={ name} onChange={handleNameChange}></input>
                <label className='email-label'>Telefonnummer</label>
                <input className='email-input' maxLength='8' type='text' placeholder='Indtast telefonnummer' onChange={handleNumberChange} value={tlfNumber}></input>
                <label className='email-label'> Nuværende adgangskode</label>
                <input className='password email-input' type='password' value={current_pw}></input>
                <label className='email-label'> Ny adgangskode</label>
                    <input className='password email-input' type='password' onChange={handlePasswordChange}></input>
                    {passwordValidationCheck === true ?
                        <div className='password-suggestions'>
                            Password should have:
                            <ul>
                                {minimum === false ? <li>Minimum of 8 characters</li> : null}
                                {isUppercase === false ? <li>At least one uppercase letter</li> : null}
                                {isNumber === false ? <li>At least one number</li> : null}
                                {specialCharacter === false ? <li>At least one special character</li> : null}

                            </ul>
                        </div>
                        : null}
                <label className='email-label'>Gentag ny adgangskode</label>
                <input className='email-input' type='password' onChange={handleRepeatPasswordChange}></input>
                <button type="submit" className='send_btn' onClick={handleSubmit}>Gem profiloplysninger</button>
                {error === true ?
                        <div className='error-div'>
                        {networkError && <span>{networkError}</span>}
                        {nameError && <span>{nameError}</span>}
                        {numberError && <span>{numberError}</span>}
                        {passwordError && <span>{passwordError}</span>}
                        {passwordRepeatError && !passwordError && <span>{passwordRepeatError}</span>}
                        {noPasswordMatch && <span>{noPasswordMatch}</span>}
                    </div> : null}
                <button className='delete-profile' onClick={deleteProfile }>Slet profil</button>
            </div>
            }
        </main>
    )
}

export default AdminProfile